import JSCookie from 'js-cookie';

const sessionPrefix = process.env.REACT_APP_SESSION_PREFIX;
const tokenCookieName = `${sessionPrefix}:token`;
const langCookieName = `${sessionPrefix}:lang`;

export const TokenSession = {
    set: token => JSCookie.set(tokenCookieName, token),
    unset: () => JSCookie.remove(tokenCookieName),
    get: () => {
        const token = JSCookie.get(tokenCookieName);
        if (!token) return null;
        return typeof token === 'object' ? token : JSON.parse(token);
    },
    formatToken: data => ({
        type: data.token_type || 'Bearer',
        token: data.access_token,
        refreshToken: data.refresh_token,
        expiration: data.expires_in,
    }),
};

export const LangSession = {
    set: token => JSCookie.set(langCookieName, token),
    unset: () => JSCookie.remove(langCookieName),
    get: () => JSCookie.get(langCookieName),
};

export default {
    Token: TokenSession,
    Lang: LangSession,
};
